module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "possible-efforts-sub-menu"
  }, [_c('div', {
    staticClass: "switcher"
  }, [_c('div', {
    staticClass: "item",
    class: {
      'selected': _vm.selectedItem === 'moreTime'
    },
    on: {
      "click": function($event) {
        _vm.selectedItem = 'moreTime'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.texts.moreTime.boksTekst))])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    class: {
      'selected': _vm.selectedItem === 'lessSickness'
    },
    on: {
      "click": function($event) {
        _vm.selectedItem = 'lessSickness'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.texts.lessSickness.boksTekst))])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    class: {
      'selected': _vm.selectedItem === 'rightPeople'
    },
    on: {
      "click": function($event) {
        _vm.selectedItem = 'rightPeople'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.texts.rightPeople.boksTekst))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'moreTime'),
      expression: "selectedItem === 'moreTime'"
    }]
  }, [_c('div', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('div', {
    staticClass: "lg",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.texts.moreTime.tykTekst1) + "\n                    " + _vm._s(_vm._f("number")(_vm.data.more_time.percentage_with_customers)) + "%\n                    "), _c('br'), _c('br'), _vm._v("\n                    " + _vm._s(_vm.texts.moreTime.tykTekst2) + "\n                    " + _vm._s(_vm._f("currency")(_vm.data.more_time.possible_revenue_increase)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "sub",
    domProps: {
      "innerHTML": _vm._s(_vm.texts.moreTime.tyndTekst1)
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.texts.moreTime.tyndTekst1) + "\n                ")])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                            Hvad bruger vi tiden på i dag?\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.moreTimeColumns,
      "rows": _vm.data.more_time.table,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'type') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                        " + _vm._s(props.row.type) + "\n                                    ")]) : (props.column.field == 'percentage') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                        " + _vm._s(_vm._f("number")(props.row.percentage)) + "%\n                                    ")]) : (props.column.field == 'hours') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                        " + _vm._s(_vm._f("number")(props.row.hours)) + "\n                                    ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                                    Ingen data ...\n                                ")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "foot right"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.goToRoute('EmployeesLearning', 'timeUsage')
      }
    }
  }, [_vm._v("\n                        Gå til \"Hvad bruger vi tiden på?\" →\n                    ")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'lessSickness'),
      expression: "selectedItem === 'lessSickness'"
    }]
  }, [_c('div', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('div', {
    staticClass: "lg",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.texts.lessSickness.tykTekst1) + "\n                    " + _vm._s(_vm._f("number")(_vm.data.less_sickness.percentage)) + "%\n                    "), _c('br'), _c('br'), _vm._v("\n                    " + _vm._s(_vm.texts.lessSickness.tykTekst2) + "\n                    " + _vm._s(_vm._f("currency")(_vm.data.less_sickness.possible_revenue_increase)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "sub",
    domProps: {
      "innerHTML": _vm._s(_vm.texts.lessSickness.tyndTekst1)
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.texts.lessSickness.tyndTekst1) + "\n                ")])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                            Medarbejdernes sygefravær\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.employeesSicknessRateColumns,
      "rows": _vm.data.employees_sickness_rate,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.employeesSicknessRateSortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'name') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                        " + _vm._s(props.row.name) + "\n                                    ")]) : (props.column.field == 'sickness_percentage') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                        " + _vm._s(_vm._f("number")(props.row.sickness_percentage)) + "%\n                                    ")]) : (props.column.field == 'sickness_hours') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                        " + _vm._s(_vm._f("number")(props.row.sickness_hours)) + "\n                                    ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                                    Ingen data ...\n                                ")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "foot right"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.goToRoute('EmployeesLearning', 'timeUsage')
      }
    }
  }, [_vm._v("\n                        Gå til \"Hvad bruger vi tiden på?\" →\n                    ")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'rightPeople'),
      expression: "selectedItem === 'rightPeople'"
    }]
  }, [_c('div', {
    staticClass: "lg"
  }, [_vm._v("\n            " + _vm._s(_vm.texts.rightPeople.tykTekst1) + "\n            " + _vm._s(_vm._f("currency")(_vm.employeesRightPeoplePossibleRevenue)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "sub"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.texts.rightPeople.tyndTekst1)
    }
  }, [_vm._v("\n                " + _vm._s(_vm.texts.rightPeople.tyndTekst1) + "\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "padding-right": "15px"
    }
  }, [_vm._v("Antal timer brugt på alle kundeopgaver i perioden")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("number")(_vm.data.right_people.total_coverage / _vm.data.right_people.avg_coverage_per_hour)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding-right": "15px"
    }
  }, [_vm._v("Gennemsnitligt dækningsbidrag pr. time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(_vm.data.right_people.avg_coverage_per_hour)))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "employees.employeeRevenue"
    }
  }), _vm._v("\n                    Hvordan er medarbejdernes indtjening?\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.rightPeopleColumns,
      "rows": _vm.data.right_people.table,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.rightPeopleSortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'total_projects') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.total_projects) + "\n                            ")]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description"
        }, [_vm._v("\n                                " + _vm._s(props.row.name) + "\n                            ")]) : (props.column.field == 'coverage') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                            ")]) : (props.column.field == 'invoices_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "foot"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.goToRoute('ProjectsLearning', 'projectTypeSkills')
      }
    }
  }, [_vm._v("\n                Gå til \"Hvilke svende er gode til hvilke opgaver?\" →\n            ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01021fb3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/PossibleEfforts/employees.vue
// module id = 788
// module chunks = 0